import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import xss from 'xss';
import {removeAds, renderMoney, replaceNewHost, storage} from '../../utils';
import ClassroomCardPopupItem from './ClassroomCardPopupItem';
import ClassroomQuickListen from './ClassroomQuickListen';
import '../../styles/classroom/ClassroomDiscussArea.css';
import Config from '../../config'
import redPacket from "../../images/redPacket3x.png"
import popular from "../../images/popular3x.png"
import listen from '../../images/icon-listen.png'
import { setEvent } from '../../services';
import { isChannelCPS } from '../../utils/cps';

class DiscussPopupItem extends Component {
    constructor() {
        super();
        this.state = {
            modifyDiscuss: null
        };
    }

    componentWillMount() {
        this.handleDiscussLength()
    }

    handleDiscussLength() {
        const {content} = this.props.message;
        if (content.length > 46) {
            let newContent = content.substring(0, 46);
            newContent += '...';
            this.setState({
                modifyDiscuss: newContent
            })
        }
    }

    render() {
        const {modifyDiscuss} = this.state;
        const {message, onShowDiscussPanel} = this.props;
        return (<div className="dz-popup-item-origin">
            <div className="inline-origin" key={message.id}>
                <div className="weui-flex">
                    <div className="weui-flex__item flex_5">
                        <div className="text pop-content align-center default-hover" onClick={onShowDiscussPanel}>
                            <p className="text-ellipsis-newline">{xss(modifyDiscuss || message.content)}</p>
                        </div>
                    </div>
                    <div className="weui-flex__item flex_1">
                        <div className="avatar default-hover" onClick={onShowDiscussPanel}>
                            <img className="circle" alt="" src={replaceNewHost(message.account.small_avatar_url)}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }
}


class RewardPopupItem extends Component {
    render() {
        const {message, handleReward} = this.props;
        return (<div className="dz-popup-item-origin dz-popup-item-reward">
            <div className="inline-origin" key={message.id}>
                <div className="weui-flex red-packet-div">
                    <div className="weui-flex__item flex_5">
                        <div className="pop-content" onClick={e => handleReward(message.reward_receiver)}>
                            <img src={redPacket} alt=""/>
                            <span className="red-packet-money">&yen;{message.money}</span>
                            <p className="red-packet-font">
                               {removeAds(message.content)}
                            </p>
                        </div>
                    </div>
                    <div className="weui-flex__item flex_1">
                        <div className="avatar default-hover" onClick={e => handleReward(message.reward_receiver)}>
                            <img className="circle" alt="" src={replaceNewHost(message.account.small_avatar_url)}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }
}


class OriginPopupItem extends Component {
    render() {
        let {message, onShowDiscussPanel, handleReward} = this.props;

        if (message.type === 'reward' && !message.money) {
            if(message.meta && message.meta.sender){
                message.money = renderMoney(message.meta.fee);
                message.content = message.meta.sender.nickname + message.meta.tip;
                message.reward_receiver = message.meta.receiver;
            }else{
                let re = /\d{1,3}/gi;
                let re2 = /\s\d{1,3}元红包$/;
                const money2 = message.content.match(re2)[0];
                message.money = money2.match(re);
                message.content = message.content.replace(re2, '');
            }
        }

        let itemContent = null;
        switch (message.type) {
            case 'reward':
                itemContent = <RewardPopupItem message={message} handleReward={handleReward} />;
                break;
            case 'handleCard':
                itemContent = <ClassroomCardPopupItem message={message} onShowDiscussPanel={onShowDiscussPanel} />;
                break;
            default:
                itemContent = <DiscussPopupItem message={message} onShowDiscussPanel={onShowDiscussPanel} />;
                break;
        }

        return (itemContent);
    }
}

class ClassroomDiscussArea extends React.PureComponent {
    constructor() {
        super();
        this.onShowDiscussPanel = this.onShowDiscussPanel.bind(this);
        this.onScrollBottom = this.onScrollBottom.bind(this);
        this.onInitDiscussListArea = this.onInitDiscussListArea.bind(this);
        this.handleReward = this.handleReward.bind(this);
        this.onToggleDiscussListArea = this.onToggleDiscussListArea.bind(this);
    }

    componentDidMount() {
        let {lecture} = this.props;
        axios.get(`/api/classroom/${lecture.id}/discuss/list`).then(res => {
            const {discusses} = res.data.data;
            this.props.dispatch({
                type: 'POPUP_LOAD',
                payload: {
                    popups: discusses.reverse().slice(-3)
                }
            })
        });

        // 评论区域展示
        this.onInitDiscussListArea();

        // 评论区域置底
        this.onScrollBottom();
    }

    componentWillUnmount() {
        this.delayPopupTimer && clearInterval(this.delayPopupTimer)
    }

    componentWillReceiveProps (props) {
        const popupList = props.popupList
        if (
            !props.showDiscussListArea ||
            popupList.delayPopups.length === 0 ||
            props.lecture.status !== 'closed' ||
            popupList.delayPopups.length === this.props.popupList.delayPopups.length
        ) {
            return
        }

        this.delayPopupTimer && clearInterval(this.delayPopupTimer)
        this.delayPopupTimer = setTimeout(() => {
            props.dispatch({
                type: 'POPUP_RECEIVE',
                payload: { ...popupList.delayPopups[0], type: 'popup' }
            });
            props.dispatch({
                type: 'DELAY_POPUP_SHIFT',
            });
        }, 500)
    }

    componentDidUpdate() {
        this.onScrollBottom();
    }

    onInitDiscussListArea() {
        const {canDiscuss} = this.props;
        if (!canDiscuss) {
            this.props.dispatch({type: 'CLASSROOM_HIDE_DISCUSS_LIST_AREA'})
        }
    }

    handleReward(account) {
        if(!account)
            return
        this.props.dispatch({
            type: 'CLASSROOM_SHOW_REWARD',
            payload: {
                account: account
            }
        })
    }

    onShowDiscussPanel() {
        if (isChannelCPS()) {
            return
        }
        this.props.dispatch({
            type: 'CLASSROOM_SHOW_DISCUSS_PANEL',
            payload: 'discuss_list'
        })
    }

    onToggleDiscussListArea() {
        if (this.props.showDiscussListArea) {
            this.context.page.showTips('已关闭弹幕')
            this.props.dispatch({type: 'CLASSROOM_HIDE_DISCUSS_LIST_AREA'})
        } else {
            this.context.page.showTips('已开启弹幕', 'primary')
            this.props.dispatch({type: 'CLASSROOM_SHOW_DISCUSS_LIST_AREA'})
        }
    }

    onShowRewardRank() {
        this.props.dispatch({
            type: 'CLASSROOM_SHOW_DISCUSS_PANEL',
            payload: 'reward_rank'
        })
    }

    onScrollBottom() {
        let {showDiscussListArea} = this.props;
        if (showDiscussListArea) {
            let container = document.getElementById('dz-popup-list');
            let containerHeight = container.clientHeight;
            let containerRealHeight = container.scrollHeight;
            container.scrollTop = containerRealHeight - containerHeight + 50;
        }
    }
    render() {
        const {showDiscussArea, showDiscussListArea, reply, popupList, stats, role, lecture, messageList} = this.props;
        const audioMsgLenth = messageList.messages.filter(item => {return item.msg_type === 'voice'}).length

        // 已结束 && 非音频和视频 && 学员 && 语音条数大于1
        const showEasyListen =
            ['audio', 'video'].indexOf(lecture.image_mode) === -1
            && lecture.status === 'closed' && !role.is_manager && !role.is_lecturer
            && audioMsgLenth > 1

        // 已结束的直播课，在学员身份下默认进入直播课
        // if (showEasyListen && !(/is_from_classroom2=1/.test(location.href))) {
        //     location.assign('/classroom2/' + lecture.id)
        // }

        if (!showDiscussArea) {
            return null;
        }
        let buttonsHeight = 50;
        let bottom = 0
        let marginBottom = 18
        if (reply) {
            bottom += 36
            marginBottom += 36
        }
        if (showEasyListen) {
            bottom = 42
        }
        const buttonsStyle = {
            height: buttonsHeight + 'px',
            bottom: bottom + 'px'
        }
        const popupListBottom = bottom + buttonsHeight;
        const popularStyle = {
            marginBottom: marginBottom + 'px',
            bottom: bottom + 'px'
        }

        let receivePopups = popupList.popups.slice(-5);
        if (!role.is_manager) {
            receivePopups = receivePopups.map((item) => {
                // 卡片的系统消息跳过检查
                if (item.type !== 'handleCard') {
                    item.content = removeAds(item.content);
                }
                return item;
            });
        }

        // 风控需求
        // const isBlockDate = (() => {
        //     const date = new Date()
        //     const m = date.getMonth() + 1 // 月份从 0 开始的坑
        //     const d = date.getDate()
        //     return m === 6 && (d >= 3 && d <= 6)
        // })()

        // if (isBlockDate) {
        //     receivePopups = []
        // }

        return (<div className="classroom-discuss-area">
            {showDiscussListArea &&
            <div
                id="dz-popup-list"
                className="dz-popup-list"
                style={{bottom: popupListBottom, right: window.platform === 'pc' ? "15px" : "10px"}}
            >
                {receivePopups.map((m) => {
                    return <OriginPopupItem message={m} key={m.id}
                        handleReward={this.handleReward}
                        onShowDiscussPanel={this.onShowDiscussPanel}
                    />
                })}
            </div>
            }

            {showDiscussListArea &&
            <div className="lecture-popular" onClick={this.onShowDiscussPanel} style={popularStyle}>
                <p><img src={popular} alt="" /> {stats.popular}</p>
            </div>
            }
            <div className="buttons" style={buttonsStyle}>
                <div className="discuss default-hover" onClick={this.onToggleDiscussListArea}>
                    {
                        showDiscussListArea ? '关' : '弹'
                    }
                </div>
            </div>
            {showEasyListen && !isChannelCPS() &&
            <div>
                <ClassroomQuickListen />
                <a className="lecture-listen" onClick={() => {
                    storage.setItem(`wkShowQuickListen`, 1);
                    if (this.props.showQuickGuide) {
                        setEvent({ name: 'wk-click-listen-entry__guide' })
                    }
                    setEvent({ name: 'wk-click-listen-entry__total' })
                    location.assign(`${Config.MAIN_URL}/classroom2/${lecture.id}`);
                }}>
                    <p>听老师说<img src={listen}/></p>
                </a>
            </div>
            }
        </div>);
    }
}


ClassroomDiscussArea.contextTypes = {
    page: React.PropTypes.object
};

export default connect((state) => ({
    showQuickGuide: state.classroom.showQuickGuide,
    messageList: state.messageList,
    popupList: state.popupList,
    account: state.account,
    showDiscussArea: state.classroom.showDiscussArea,
    showDiscussListArea: state.classroom.showDiscussListArea,
    lecture: state.classroom.lecture,
    stats: state.classroom.stats,
    reply: state.classroom.reply,
    role: state.classroom.role,
    canDiscuss: state.classroom.options.can_discuss,
}))(ClassroomDiscussArea);




// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomDiscussArea.js